/**
 * 时间粒度工具函数
 * 提供时间粒度的中文显示名称映射
 */

// 时间粒度中文描述映射（完整的K线时间粒度映射）
export const timeFrameLabelMap: Record<string, string> = {
  '1m': '1分钟',
  '3m': '3分钟',
  '5m': '5分钟',
  '15m': '15分钟',
  '30m': '30分钟',
  '1H': '1小时',
  '2H': '2小时',
  '4H': '4小时',
  '6H': '6小时',
  '12H': '12小时',
  '1D': '1天',
  '1W': '1周',
  '1M': '1月',
  // 兼容小写格式
  '1h': '1小时',
  '2h': '2小时',
  '4h': '4小时',
  '6h': '6小时',
  '12h': '12小时',
  '1d': '1天',
  '1w': '1周',
  '1month': '1月',
  // 其他时间周期（用于告警等）
  '7d': '7天',
  '14d': '14天',
  '30d': '30天',
};

/**
 * 规范化时间粒度字符串（处理大小写问题）
 * @param timeFrame 时间粒度（如 "5m", "1H", "1D", "5M", "1h" 等）
 * @returns 规范化后的时间粒度字符串
 */
function normalizeTimeFrame(timeFrame: string): string {
  if (!timeFrame) return timeFrame;

  // 特殊处理：1M 表示 1月（而不是 1分钟）
  if (timeFrame.toUpperCase() === '1M' && timeFrame !== '1m') {
    return '1month';
  }

  // 转换为小写进行匹配
  return timeFrame.toLowerCase();
}

/**
 * 根据时间粒度获取中文显示名称（大小写不敏感）
 * @param timeFrame 时间粒度（如 "5m", "1H", "1D", "5M", "1h" 等）
 * @returns 中文显示名称（如 "5分钟", "1小时", "1天" 等）
 */
export function getTimeFrameName(timeFrame: string): string {
  if (!timeFrame) return timeFrame;

  // 先尝试直接匹配
  if (timeFrameLabelMap[timeFrame]) {
    return timeFrameLabelMap[timeFrame];
  }

  // 规范化后匹配（大小写不敏感）
  const normalized = normalizeTimeFrame(timeFrame);
  if (timeFrameLabelMap[normalized]) {
    return timeFrameLabelMap[normalized];
  }

  // 尝试在所有键中查找匹配（忽略大小写）
  const matchedKey = Object.keys(timeFrameLabelMap).find((key) => key.toLowerCase() === normalized);
  if (matchedKey) {
    return timeFrameLabelMap[matchedKey];
  }

  return timeFrame;
}
